/*
 * @Author: your name
 * @Date: 2021-12-21 12:41:24
 * @LastEditTime: 2022-03-01 15:58:08
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \hello\src\main.js
 */
import { createApp } from "vue";
import Toast from "vue-toastification";
// import vue from 'vue'
// import VModal from "vue-js-modal/dist/index.nocss.js";
// import Vconsole from 'vconsole';
import VueSocialSharing from 'vue-social-sharing'
import "vue-toastification/dist/index.css";
import router from "./router";
import App from "./App.vue";
import store from "./store/index";
import "./app.less";
import i18n from "./lang/index";
// import Tips from './components/Tips/Tips.vue'
// import Vconsole from "vconsole";
// const vConsole = new Vconsole();
import loaded from './utils/loading'

import ElementPlus from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "element-plus/dist/index.css";


 const app = createApp(App);
 
 app.use(ElementPlus, {
  locale: zhCn,
});

app.use(Toast, {
  shareAppContext: true,
});
app.directive('title',{
  inserted:function(el){
    document.title = el.dataset.title
  }
})
// let vConsole = new Vconsole();
// app.use (vConsole);
app.use(VueSocialSharing);
app.use(router);
app.use(store);
app.use(VueSocialSharing);
// app.use(VModal, { dialog: true });
app.use(i18n);
app.directive('loading',loaded)
// app.use(Tips);
app.mount("#app");
export default app;